import Icon from 'atomic/icon';
import React from 'react';
import Circle from 'atomic/circle/circle';
import classNames from 'classnames';
import { usePagination } from 'components/paginations/use-pagination';
import { PaginationProps } from 'components/paginations/pagination.interface';

import './pagination-mini.scss';
import { toNumber } from 'underscore.string';

const PaginationMini: React.FC<PaginationProps> = ({
    count,
    siblingCount = 1,
    page,
    limit,
    getUrl
}) => {
    const paginationRange = usePagination(
        count,
        limit,
        siblingCount,
        page
    );

    if (page === 0) {
        return null;
    }

    const lastPage = paginationRange[paginationRange.length - 1];

    const change = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = parseInt(event.target.value, 10);

        if (value > toNumber(lastPage as string) || value < 0) {
            event.target.value = page.toString();
        }
    };

    const enter = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.charCode === 13) {
            window.location.replace(getUrl(parseInt((event.target as HTMLInputElement).value)));
        }
    };

    return (
        <div className="pagination-mini">
            { page !== 1 && (
                <a
                    href={getUrl(page - 1)}
                    className={classNames(
                        {
                            ['pagination-mini__item']: true,
                            ['pagination-mini__item--prev']: true
                        }
                    )}
                    aria-label="Wstecz"
                >
                    <Circle
                        tag="div"
                        background="transparent"
                        border="secondary"
                        color="secondary"
                    >
                        <Icon name="arrow-left" color="secondary" size={16} />
                    </Circle>
                    <span>Wstecz</span>
                </a>
            )}
            <div
                className={classNames(
                    {
                        ['pagination-mini-range']: true
                    }
                )}
            >
                {
                    <div className="pagination-mini__content">
                        <div className="pagination-mini__item">
                            <input className="pagination-mini-input" type="number" value={page}
                                min={1}
                                max={lastPage}
                                onChange={change}
                                onKeyPress={enter}
                                aria-label={`Strona ${page}`}
                            />
                        </div>
                        <Circle
                            className="pagination-mini__item"
                            tag="div"
                            background="transparent"
                            border="transparent"
                            color="dark"
                        >
                            <span className="pagination-mini__item-page">z {lastPage}</span>
                        </Circle>
                    </div>
                }
            </div>
            { lastPage !== page && (
                <a
                    href={getUrl(page + 1)}
                    className={classNames(
                        {
                            ['pagination-mini__item']: true,
                            ['pagination-mini__item--next']: true
                        }
                    )}
                    aria-label="Dalej"
                >
                    <span>Dalej</span>
                    <Circle
                        tag="div"
                        background="transparent"
                        border="secondary"
                        color="secondary"
                    >
                        <Icon name="arrow-right" color="secondary" size={16} />
                    </Circle>
                </a>
            )}
        </div>
    );
};

export default PaginationMini;
